import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { TopNav } from './TopNav';
import { useAuth } from '@/hooks/useAuth';
import { Toaster } from '../ui/Toaster';
import { Skeleton } from '../ui/Skeleton';

export function AppShell() {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50">
        <div className="h-14 bg-ink" />
        <div className="max-w-7xl mx-auto p-6 space-y-4">
          <Skeleton className="h-12 w-1/3" />
          <Skeleton className="h-32" />
          <Skeleton className="h-32" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <TopNav user={user} onLogout={logout} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <Outlet context={{ user }} />
      </main>
      <Toaster />
    </div>
  );
}
